import React from 'react';
import classnames from 'classnames';
import styles from '../SiteLinks/SiteLinks.module.scss';
import { Div, Link, LinkAdapter } from '@gaiads/telia-react-component-library';

export interface TopBarItemShape {
  url?: string;
  text: string;
  active?: boolean;
  onClick?: (e: React.SyntheticEvent<HTMLDivElement>) => void;
}

type SiteLinkProps = {
  /** SiteLink link */
  link: TopBarItemShape;
  /** Custom Link component */
  linkAdapter?: LinkAdapter;
};

const SiteLink: React.FunctionComponent<SiteLinkProps> = ({ link, linkAdapter }: SiteLinkProps) => {
  return (
    <Div
      data-testid="site-link"
      key={link.text}
      onClick={
        link.url
          ? undefined
          : event => {
              event.preventDefault();
              if (link.onClick) link.onClick(event);
            }
      }
      className={classnames({
        [styles.siteLinks_siteLink]: true,
        [styles.siteLinks_siteLink__active]: link.active,
      })}
    >
      <Link
        data-testid="site-link-link"
        className={styles.siteLinks_link}
        to={link.url}
        color={link.active ? 'black' : 'gray500'}
        hoverColor="black"
        linkAdapter={linkAdapter}
      >
        {link.text}
      </Link>
    </Div>
  );
};

export default SiteLink;
